import { render, staticRenderFns } from "./notifications.page.vue?vue&type=template&id=148b7be4&scoped=true"
import script from "./notifications.page.vue?vue&type=script&lang=ts"
export * from "./notifications.page.vue?vue&type=script&lang=ts"
import style0 from "./notifications.page.vue?vue&type=style&index=0&id=148b7be4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148b7be4",
  null
  
)

export default component.exports